export default __webpack_public_path__ + "static/media/certi5.d9acfbb8.png";